import { useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

const TermsOfService = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, []);

  return (
    <div className="min-h-screen" data-testid="terms-of-service-page">
      <Header onBookClick={() => {}} />
      
      <main className="section-padding bg-white">
        <div className="container-custom max-w-4xl">
          <div className="mb-8">
            <Link to="/" className="text-sky-600 hover:underline text-sm">
              ← Back to Home
            </Link>
          </div>
          
          <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-8">
            Terms of Service
          </h1>
          
          <p className="text-slate-500 mb-8">Last Updated: December 2025</p>
          
          <div className="legal-content">
            <p>
              Welcome to Nova Shelf. By using our website and services, you agree to 
              these Terms of Service. Please read them carefully.
            </p>

            <h2>1. Services</h2>
            <p>
              Nova Shelf provides residential house cleaning services in the Houston, 
              Texas metropolitan area. Our services include standard cleaning, deep 
              cleaning, move-in/move-out cleaning, and recurring cleaning services.
            </p>

            <h2>2. Service Scheduling</h2>
            <h3>Booking</h3>
            <p>
              Services can be scheduled through our website, by phone, or by email. 
              All appointments are subject to availability and confirmation by our team.
            </p>
            <h3>Cancellation Policy</h3>
            <ul>
              <li>Cancellations made 24 hours or more before the scheduled service: No charge</li>
              <li>Cancellations made less than 24 hours before: May be subject to a cancellation fee</li>
              <li>No-shows: Full service fee may apply</li>
            </ul>

            <h2>3. Pricing and Payment</h2>
            <p>
              Service pricing is based on factors including home size, service type, 
              cleaning frequency, and specific requirements. We provide estimates before 
              service delivery. Final pricing may vary based on actual conditions.
            </p>
            <p>
              Payment is due upon completion of service unless otherwise arranged. 
              We accept various payment methods including credit cards and electronic 
              payments.
            </p>

            <h2>4. Access and Preparation</h2>
            <p>
              Customers are responsible for providing access to the property at the 
              scheduled time. We recommend:
            </p>
            <ul>
              <li>Securing pets in a safe area</li>
              <li>Removing valuable items or securing them</li>
              <li>Providing clear access to areas to be cleaned</li>
              <li>Informing us of any special instructions or concerns</li>
            </ul>

            <h2>5. Service Quality</h2>
            <p>
              We strive to deliver high-quality cleaning services. If you are not 
              satisfied with any aspect of our service, please contact us within 24 
              hours and we will work to address your concerns.
            </p>

            <h2>6. Liability</h2>
            <p>
              Nova Shelf takes reasonable care while providing services. However, we 
              are not liable for:
            </p>
            <ul>
              <li>Pre-existing damage or conditions</li>
              <li>Items not disclosed as fragile or valuable</li>
              <li>Damage resulting from defective or unstable items</li>
              <li>Consequential or indirect damages</li>
            </ul>
            <p>
              Any claims for damage must be reported within 24 hours of service 
              completion with supporting documentation.
            </p>

            <h2>7. Customer Responsibilities</h2>
            <p>Customers agree to:</p>
            <ul>
              <li>Provide accurate information when booking services</li>
              <li>Ensure a safe working environment for our team</li>
              <li>Inform us of any hazardous materials or conditions</li>
              <li>Treat our staff with respect</li>
            </ul>

            <h2>8. Privacy</h2>
            <p>
              Your privacy is important to us. Please refer to our Privacy Policy for 
              information on how we collect, use, and protect your personal information.
            </p>

            <h2>9. Modifications</h2>
            <p>
              We reserve the right to modify these Terms of Service at any time. 
              Changes will be effective upon posting to our website. Continued use of 
              our services constitutes acceptance of any modifications.
            </p>

            <h2>10. Contact Information</h2>
            <p>For questions about these Terms of Service, please contact us:</p>
            <ul>
              <li>Email: support@novashelf.store</li>
              <li>Phone: +1-888-453-2345</li>
              <li>Address: 1587 Magnolia Court, Houston, TX 77002</li>
            </ul>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default TermsOfService;
